// host-redirect.js — self-healing URL rewrite.
//
// Hanko's session cookie is scoped to .samsurveyor.com. It will only ride
// on requests from a *.samsurveyor.com host. If Console opens the Designer
// at the legacy cloudsam-designer-*.run.app URL (because its sysconfig
// hasn't been re-pointed yet, or there's a stale tab open), the cookie
// isn't accessible and every /me call 401s.
//
// This module runs as a side effect on import. Import it as the FIRST
// thing in index.js (before hanko-init or anything that touches React)
// so the rewrite happens before any auth code has a chance to fire.
// No-op when already on samsurveyor.com or localhost.

try {
    const loc = (typeof window !== 'undefined') ? window.location : null;
    if (loc && /\.run\.app$/i.test(loc.hostname)) {
        const target = `https://designer.samsurveyor.com${loc.pathname}${loc.search}${loc.hash}`;
        // replace() so the run.app URL doesn't pollute browser history.
        loc.replace(target);
    }
} catch (_) {
    // Best-effort — fall through to normal boot if anything goes wrong.
    // The bounce page will at least show diagnostics on the wrong host.
}
